import "./SidePanelItem.less";
import * as React from "react";
import { BaseResponsiveComponent, IBaseResponsiveComponentProps } from "../../BaseResponsiveComponent";
import { CSSProperties } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { computed } from "mobx";
import { inject, observer } from "mobx-react";

export const SINGLE_LINE_SECTION_HEIGHT = 57; // We use that while we are waiting for a solution that won't be based on absolute positioning.

export type SidePanelSize = "sm" | "lg";

export interface ISidePanelItem extends IBaseResponsiveComponentProps {
    panelContent: React.ReactNode;
    panelKey: string;
    panelLabel: string;
    panelIcon: IconProp;
    panelSize?: SidePanelSize;
    externalVerticalOffset?: number; // We use that while we are waiting for a solution that won't be based on absolute positioning.
    headerContent?: React.ReactNode;
    hideTitle?: boolean;
    customHeaderHeight?: number;
    isContentScrollable?: boolean;
    onClick?: () => void;
    className?: string;
}

export interface ISidePanelItemProps extends ISidePanelItem {
    setActivePanelItem: (panelKey: string) => void;
}

@inject()
@observer
class SidePanelItem extends BaseResponsiveComponent<ISidePanelItemProps> {
    public static defaultProps = {
        hideTitle: false,
        baseVerticalOffset: 0,
    };

    @computed protected get rootElementClassName(): string | undefined {
        const { className, panelSize = "sm" } = this.props;

        return `SidePanelItem ${className ?? ""} size-${panelSize}`;
    }

    setActivePanelItem = () => {
        const { panelKey, setActivePanelItem } = this.props;

        setActivePanelItem(panelKey);
    };

    renderAll() {
        const {
            panelLabel,
            hideTitle,
            panelContent,
            headerContent,
            customHeaderHeight = 0,
            externalVerticalOffset = 0,
            isContentScrollable = true,
        } = this.props;

        let headerHeight = 0;
        if (headerContent) {
            headerHeight = customHeaderHeight > 0 ? customHeaderHeight : SINGLE_LINE_SECTION_HEIGHT;
        }
        const absolutePanelOffset = headerHeight + (!hideTitle ? SINGLE_LINE_SECTION_HEIGHT : 0);

        let contentClassName = "content";
        const headerClassName = "header";

        /*
        if (!headerContent) {
            contentClassName += " no-header";
        }

        if (hideTitle) {
            contentClassName += " no-title";
        }
        */
        if (isContentScrollable) {
            contentClassName += " scrollable";
        }

        const headerStyle: CSSProperties = {
            height: headerHeight,
        };
        const contentStyle: CSSProperties = {
            top: absolutePanelOffset,
            height: `calc(100% - ${externalVerticalOffset + absolutePanelOffset}px)`,
        };

        return (
            <>
                {!hideTitle && (
                    <div className="panel-title-header">
                        <h3>{panelLabel}</h3>
                        <div className="close-icon-container" onClick={this.setActivePanelItem}>
                            <FontAwesomeIcon icon={["far", "times"]} size={"lg"} />
                        </div>
                    </div>
                )}
                {headerContent && (
                    <div className={headerClassName} style={headerStyle}>
                        {headerContent}
                    </div>
                )}
                {panelContent && (
                    <div className={contentClassName} style={contentStyle}>
                        {panelContent}
                    </div>
                )}
            </>
        );
    }
}

export default SidePanelItem;
